import React from 'react'
import "./index.css"
const Page404 = () => {
  return (
    <div >
      <div className="error-page ">
      <div className="error-container">
        <div className="illustration">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            className="astronaut-svg"
          >
            <circle cx="50" cy="50" r="48" fill="none" stroke="#000" strokeWidth="2" />
            <path
              d="M50 20 L58 30 L50 40 L42 30 Z"
              fill="none"
              stroke="#000"
              strokeWidth="2"
            />
            <line x1="50" y1="40" x2="50" y2="70" stroke="#000" strokeWidth="2" />
            <circle cx="50" cy="75" r="5" fill="#000" />
            <circle cx="50" cy="10" r="3" fill="#000" />
          </svg>
        </div>
        <div className="text-container">
          <h1>404</h1>
          <h2>UH OH! You're lost.</h2>
          <p>
            The page you are looking for does not exist. How you got here is a
            mystery. But you can click the button below to go back to the
            homepage.
          </p>
          <a href="/" className="home-button">
            HOME
          </a>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Page404
